const comments = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20warm%20smile%20and%20pink%20background%2C%20simple%20flat%20illustration%2C%20social%20media%20profile%20picture&width=120&height=120&seq=bbtv-avatar-01&orientation=squarish',
    time: '2小时前',
    content: '棒棒TV真的太流畅了！之前在其他平台看剧总卡顿，这里完全没有这个问题。画质也很清晰，推荐！',
    likes: 128,
  },
  {
    name: '深夜刷剧党',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20with%20glasses%20and%20blue%20background%2C%20simple%20flat%20illustration%2C%20social%20media%20profile%20picture&width=120&height=120&seq=bbtv-avatar-02&orientation=squarish',
    time: '5小时前',
    content: '庆余年第二季更新好快！每天下班回来第一件事就是打开棒棒TV追更新，资源全而且没广告，体验太好了。',
    likes: 96,
  },
  {
    name: '电影收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20woman%20avatar%20with%20wavy%20hair%20and%20green%20background%2C%20simple%20flat%20illustration%2C%20social%20media%20profile%20picture&width=120&height=120&seq=bbtv-avatar-03&orientation=squarish',
    time: '昨天',
    content: '电影资源真的很全，很多经典老片都能找到。流浪地球2上线速度也很快，画质炸裂，强烈推荐给朋友们了。',
    likes: 203,
  },
  {
    name: '周末补番中',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20character%20avatar%20with%20headphones%20and%20purple%20background%2C%20simple%20flat%20illustration%2C%20social%20media%20profile%20picture&width=120&height=120&seq=bbtv-avatar-04&orientation=squarish',
    time: '2天前',
    content: '长风渡全集都上线了！一口气看了十几集，爽。界面简洁没有乱七八糟的弹窗，追剧体验特别舒服。',
    likes: 157,
  },
  {
    name: '影评人小K',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20person%20avatar%20with%20beret%20hat%20and%20yellow%20background%2C%20simple%20flat%20illustration%2C%20social%20media%20profile%20picture&width=120&height=120&seq=bbtv-avatar-05&orientation=squarish',
    time: '3天前',
    content: '作为重度影视爱好者，用了很多平台，棒棒TV的加载速度和画质表现确实排在前列。希望资源越来越丰富！',
    likes: 89,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            观众热评
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            追剧小伙伴们怎么说
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            真实观众反馈，百万用户的选择与信赖
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, idx) => (
            <article
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 hover:border-secondary-200 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 truncate">
                    {comment.name}
                  </h3>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </button>
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-chat-1-line"></i>
                  回复
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}